export enum UploadRequest{
    NEWMAIL="NEWMAIL",
    REPLY="REPLY",
    MANUALWORKITEMCONTROLLER="MANUALWORKITEMCONTROLLER"
}
